<template>
<div>
  <div class="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item> 
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  <div class="contenter">
    <div class="title">
      <span class="el-icon-document"></span>
      <span>基因数据下载</span>
    </div>
    <div class="des">
        <input type="text" v-model="keyword" class="txt" placeholder="please enter the keyword you want to search" />
        <div class="btn" @click="searchFun"><span class="el-icon-search"></span> Search</div>
    </div>
    <div class="img">
      <table cellpadding="0" cellspacing="0">
          <tr>
            <th>Version</th>
            <th>Genome</th>
            <th>GFF</th>
            <th>CDS</th>
            <th>Protein</th>
            <!-- <th>-</th> -->
          </tr>
          <tr v-for="(item,index) in tableData" :key="index">
            <td v-html="item.version"></td>
            <td v-html="item.genome"></td>
            <td v-html="item.gff"></td>
            <td v-html="item.cds"></td>
            <td v-html="item.protein"></td>
          </tr>
          <tr v-if="tableData.length<1">
            <td colspan="5">暂无数据</td>
          </tr>
        </table>
        <el-pagination
        class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="num"
          layout="sizes, prev, pager, next"
          :total="total"
        >
        </el-pagination>
    </div>  
  </div></div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
       num: 20,
      page: 1,
      total: 0,
      tableData:[],
      keyword:''
    }
  },
  created(){
    let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Login expired, please log in again", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }else{
        this.searchAll(this.num, this.page);
      }
  },
  methods: {
    searchFun(){
       if (this.keyword == "" || this.keyword == null) {
        this.$alert("请输入搜索关键词！", "Notice", {
          confirmButtonText: 'Confirm',
          callback: (action) => {},
        });
        return false;
      }else{
        this.search(this.keyword);
      }
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.num = val;
      let page=this.page;
      this.page=page;
      this.searchAll(this.num, this.page);
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.searchAll(this.num, this.page);
    },

    search(name){
        let that = this;
        let token=localStorage.getItem("authorization");
      axios
        .get("/bena/server/download/like?name="+name,{
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            that.tableData = response.data.result;
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {},
            });
          }
        })
        .catch(function (error) {
          //that.$message.error("失败!");
          //console.log(error);
        });
    },
    searchAll(num, page){
        let that = this;
        let token=localStorage.getItem("authorization");
      axios
        .get("/bena/server/download/getlist?num=" + num + "&page=" + page,{
          headers: { Authorization: token },
        })
        .then(function (response) {
          //console.log(response);
          if (response.data.code == 0) {
            that.tableData = response.data.result.list;
  
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {},
            });
          }
        })
        .catch(function (error) {
          //that.$message.error("失败!");
          //console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.contenter .pagination{
  text-align: right;
  margin-top: 20px;
}
.contenter >>> .pagination.el-pagination .el-pager .active{
  color: seagreen;
}
.contenter >>> .el-select.el-input.is-focus.el-input__inner:hover{
  border-color:seagreen;
}
.contenter {
  width: 1140px;
  margin: 0 auto;
  /* height: 500px; */
  box-shadow: 0 0 10px #bbb;
  padding: 0 30px;
  background: #fff;
  min-height: 540px;
}
.contenter .title {
  height: 70px;
  width: 100%;
  /* border: 1px solid red; */
  line-height: 70px;
  font-size: 16px;
  font-weight: bold;
}
.contenter .title .el-icon-document {
  margin-right: 10px;
  font-size: 20px;
  /* line-height: 30px; */
  color: seagreen;
  font-weight: bold;
}
.contenter .des {
  /* background: #eef6f0; */
  color: #555;
  line-height: 25px;
  padding: 15px 20px;
  font-size: 14px;
  text-indent: 30px;
  display: flex;
  justify-content: flex-end;
}
.contenter .des input.txt{
  height: 25px;
  width: 300px;
  padding-left: 10px;
}
.contenter .des .btn{
  width: 100px;
  height: 31px;
  line-height: 31px;
  background: seagreen;
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
}
.contenter .des .btn span{
  display: block;
  text-align: center;
  line-height: 31px;
  width: 30px;
  height: 31px;
  text-indent: 10px;
  margin-right: 10px;
}
.contenter .img {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  line-height: 25px;
  overflow: auto;
  padding-bottom: 30px;
}
.img table {
  width: 100%;
}
.img table tr:first-child{
  background: seagreen;
  color: #fff;
}
.img table tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  line-height: 35px;
  font-size: 13px;
}
</style>